import { Theme } from '@eversports/react-components/design-tokens/theme'
import AppPromotionImage from '@eversports/react-components/patterns/AppPromotionImage'
import AppSelfCheckInPromotionImage from '@eversports/react-components/patterns/AppSelfCheckInPromotionImage'
import Flex from '@eversports/react-components/primitives/Flex'
import StoreBadge from '@eversports/react-components/primitives/StoreBadge'
import { makeStyles } from '@mui/styles'
import React from 'react'

import Venue from '../../typings/Venue'

import AppPromotionContent from './AppPromotionContent'
import AppPromotionHeading from './AppPromotionHeading'

interface Props {
  hasSelfCheckIn: boolean
  venue: Venue
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: `0 ${theme.layoutSpacing.wide}`,
  },
  content: {
    maxWidth: 375,
  },
  img: {
    maxHeight: 415,
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },
}))

const AppPromotion: React.FC<React.PropsWithChildren<Props>> = ({ hasSelfCheckIn, venue }) => {
  const classes = useStyles()
  return (
    <Flex
      flexDirection={['column', 'column', 'row']}
      justifyContent="space-between"
      alignItems="center"
      verticalSpacing="default"
      marginTop="default"
      className={classes.container}
    >
      {hasSelfCheckIn ? <AppSelfCheckInPromotionImage /> : <AppPromotionImage />}
      <Flex flexDirection="column" verticalSpacing="default" marginLeft={['none', 'none', 'wide']}>
        <AppPromotionHeading hasSelfCheckIn={hasSelfCheckIn} />
        <AppPromotionContent hasSelfCheckIn={hasSelfCheckIn} className={classes.content} venue={venue} />
        <Flex justifyContent={['center', 'center', 'flex-start']}>
          <StoreBadge type="app-store" marginRight="default" />
          <StoreBadge type="play-store" />
        </Flex>
      </Flex>
    </Flex>
  )
}

AppPromotion.defaultProps = {
  hasSelfCheckIn: false,
}

export default AppPromotion
